// extracted by mini-css-extract-plugin
export default {"glowBadge":"Badge_glowBadge__vbWW4","glow":"Badge_glow__yXPKR"};